import type { SvgIconProps } from "@mui/material/SvgIcon";
import {
  DashboardCustomizeOutlined as DashboardIcon,
  LocalShippingOutlined as TruckIcon,
  Send as SendIcon,
  Add as PlusIcon,
  Edit as EditIcon,
  GroupOutlined as UsersIcon,
  ArticleOutlined as FileIcon,
  MonetizationOnOutlined as AttachMoneyIcon,
  Payment as PaymentIcon,
  RequestQuoteOutlined as PaymentTermsIcon,
  SoapOutlined as ReceivePaymentIcon,
  Business as BusinessIcon,
  PersonAddAltOutlined as GroupIcon,
  PersonOutlined as CustomerIcon,
  PaymentsOutlined as BillPaymentIcon,
  AccountBalanceWalletOutlined as AccountBalanceWalletIcon,
  TrendingUpOutlined as SalesIcon,
  CurrencyExchangeOutlined as PaymentsNew,
  ReceiptLongOutlined as InvoiceIcon,
  CalculateOutlined as EstimatesIcon,
  ReceiptOutlined as TaxIcon, // Tax substitute (closest in MUI)
  Inventory2Outlined as ProductIcon,
  LocalMallOutlined as ShopIcon,
  ReceiptOutlined as BillIcon, // 👈 Bill icon
  StorefrontOutlined as VendorIcon, // 👈 Available in MUI v5+
  DonutSmallOutlined as ChartAccountsIcon,
  NoteAltOutlined as JournalEntryIcon,
  ListAltOutlined as JournalEntryIconNew,
  StickyNote2Outlined as PriceChangeIcon,
  Visibility as VisibilityIcon,
  TimelineOutlined as ReportIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as BalanceSheetIcon,
  AccountBoxOutlined as DriveEtaIcon,
  Delete as DeleteIcon,
  FileUpload as FileUploadIcon,
  FileDownload as FileDownloadIcon,
  PictureAsPdf as PictureAsPdfIcon,
  ArrowForward as ArrowForwardIcon,
  LocalShipping as LocalShippingIcon,
  CreditCard as CreditCardIcon,
  ReceiptLong as ReceiptLongIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  FiberManualRecord as FiberManualRecordIcon,
  ChatBubbleOutline as Communication ,EmojiPeople as Behavior ,Payments as Payment ,BusinessCenter as BusinessStability ,ReportGmailerrorred as ReportScore,
  Cancel as CancelIcon,
  Print as PrintIcon,
  CheckCircle as CheckCircleIcon,
  ReplayCircleFilled  as ConvertIcon,
  Settings ,
  Email,
  MarkEmailRead,
  SettingsSuggest,
  Close as CloseIcon,
  OpenInNew,
  NoteAdd as CreditNoteIcon,
  NoteAlt as DebitNoteIcon,
  Update as UpdateIcon,
  ReplayCircleFilled as UpdateIconNew,
  ThumbUp as FollowUpIcon,
  Paid as ExpenseFees,
  AddCircleSharp as AddPlus,
  DoubleArrow as AddService,
  BarChart,
  EmailOutlined
} from "@mui/icons-material";

export type iconType = "barChart" | "UpdateIconNew" | "AddService" | "AddPlus" | "ExpenseFees" | "FollowUpIcon" | "OpenInNew" | "dashboard" | "BillPaymentIcon" | "drivers" | "CustomerIcon" | "truck" | "ReceivePaymentIcon" | "OutlineSend" | "JournalEntryIcon" | "PaymentsNew" | "PaymentTermsIcon" | "plus" | "edit" | "users" | "priceChange" | "visibility" | "customers" | "carriers" | "file" | "company" | "AttachMoneyIcon" | "amazonPay" | "sales" | "accountBalanceWallet" | "invoices" | "estimates" | "tax" | "product" | "purchase" | "vendors" | "bills" | "chartAccounts" | "journalEntry" | "profitAndLoss" | "balanceSheet" | "reports" | "delete" | "fileUpload" | "fileDownload" | "pictureAsPdf" | "arrowForward" | "localShipping" | "creditCard" | "receiptLong" | "GoDotFill" | "communication" | "behavior" | "payment" | "businessStability" | "reportScore" | "cancel" | "fileExport" | "fileImport" | "RemoveRedEye" | "Print" | "checkCircle" | "convert" | "settings" | "email" | "markEmailRead" | "settingsSuggest" | "CloseIcon" | "creditNote" | "debitNote"| "update"
export const getIcon = (iconName?: iconType,props: SvgIconProps = {}): React.ReactElement | null => {
  if (!iconName) return null;

  const iconMap: Record<iconType, React.ReactElement> = {
    dashboard: <DashboardIcon {...props} />,
    barChart: <BarChart {...props} />,
    update: <UpdateIcon {...props} />,
    truck: <TruckIcon {...props} />,
    drivers:<DriveEtaIcon {...props} />,
    OutlineSend: <SendIcon {...props} />,
    plus: <PlusIcon {...props} />,
    edit: <EditIcon {...props} />,
    users: <UsersIcon {...props} />,
    priceChange: <PriceChangeIcon {...props} />,
    visibility: <VisibilityIcon {...props} />,
    customers: <GroupIcon {...props} />,
    carriers: <TruckIcon {...props} />,
    file: <FileIcon {...props} />,
    company: <BusinessIcon {...props} />,
    AttachMoneyIcon: <AttachMoneyIcon {...props} />,
    amazonPay: <PaymentIcon {...props} />,
    PaymentTermsIcon: <PaymentTermsIcon {...props} />,
    ReceivePaymentIcon: <ReceivePaymentIcon {...props} />,
    sales: <SalesIcon {...props} />,
    PaymentsNew: <PaymentsNew {...props} />,
    BillPaymentIcon: <BillPaymentIcon {...props} />,
    accountBalanceWallet: <AccountBalanceWalletIcon {...props} />,
    invoices: <InvoiceIcon {...props} />,
    estimates: <EstimatesIcon {...props} />,
    tax: <TaxIcon {...props} />,
    CustomerIcon: <CustomerIcon {...props} />,
    product: <ProductIcon {...props} />,
    purchase: <ShopIcon {...props} />,
    vendors: <VendorIcon {...props} />, // ✅ replaced FaHandshake with MUI Handshake
    bills: <BillIcon {...props} />,
    chartAccounts: <ChartAccountsIcon {...props} />,
    journalEntry: <JournalEntryIcon {...props} />,
    JournalEntryIcon: <JournalEntryIconNew {...props} />,
    profitAndLoss:<>
     <TrendingUpIcon {...props} />
     <TrendingDownIcon {...props} />
    </>,
    balanceSheet: <BalanceSheetIcon {...props} />,
    reports: <ReportIcon {...props} />,
    delete:<DeleteIcon {...props} />,
    fileUpload:<FileUploadIcon {...props} />,
    fileDownload:<FileDownloadIcon {...props} />,
    pictureAsPdf:<PictureAsPdfIcon {...props} />,
    arrowForward:<ArrowForwardIcon {...props} />,
    localShipping:<LocalShippingIcon {...props} />,
    creditCard:<CreditCardIcon {...props} />,
    receiptLong:<ReceiptLongIcon {...props} />,
    GoDotFill:<FiberManualRecordIcon {...props} />,
    communication:<Communication {...props} />,
    behavior:<Behavior {...props} />,
    payment:<Payment {...props} />,
    businessStability:<BusinessStability {...props} />,
    reportScore:<ReportScore {...props} />,
    cancel:<CancelIcon  {...props} />,
    fileExport:<FileDownloadIcon {...props} />,
    fileImport:<FileUploadIcon {...props} />,
    RemoveRedEye:<RemoveRedEyeIcon {...props} />,
    Print:<PrintIcon {...props} />,
    checkCircle:<CheckCircleIcon  {...props} />,
    convert:<ConvertIcon {...props} />,
    settings:<Settings {...props} />,
    email:<EmailOutlined {...props} />,
    markEmailRead:<MarkEmailRead {...props} />,
    settingsSuggest:<SettingsSuggest {...props} />,
    CloseIcon:<CloseIcon {...props} />,
    OpenInNew:<OpenInNew {...props} />,
    creditNote:<CreditNoteIcon {...props} />,
    debitNote:<DebitNoteIcon {...props} />,
    UpdateIconNew:<UpdateIconNew {...props} />,
    FollowUpIcon:<FollowUpIcon {...props} />,
    ExpenseFees:<ExpenseFees {...props} />,
    AddPlus:<AddPlus {...props} />,
    AddService:<AddService {...props} />,
  };

  return iconMap[iconName] || null;
};
